var React = require('react');

function SizeIconMin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28 51.24V66a7 7 0 007 7h14.76l-5 5L49 82.24l10.12-10.12a3 3 0 000-4.24L49 57.76 44.76 62l5 5H35a1 1 0 01-1-1V51.24l5 5L43.24 52 33.12 41.88a3 3 0 00-4.24 0L18.76 52 23 56.24zM82 41v-3l-2.36-1.8-21-16L55 17.46l-3.64 2.77-17.82 13.58 4.28 4.28L55 25l21 16v25a1 1 0 01-1 1h-9v6h9a7 7 0 007-7z"}));
}

SizeIconMin.defaultProps = {"viewBox":"15 15 87 71","className":"size-icon"};

module.exports = SizeIconMin;

SizeIconMin.default = SizeIconMin;
